export namespace HttpRequestHeaderNames {
    export const clientVersionName = 'x-hcmc-client-version'
    export const clientPlatform = 'x-hcmc-client-platform'
    export const clientDistribution = 'x-hcmc-client-distribution'
}